import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import Svg, { Circle, Defs, LinearGradient, Stop } from 'react-native-svg';

import { MainUserIcon } from '../../../assets';
import { useSvgId } from '../../../utils/hooks/useSvgId';

const DESIGN_WIDTH = 42;
const BORDER_COLOR = 'rgba(255, 209, 77, 0.55)';
const BORDER_WIDTH = 1;
const FILL_TOP = '#21170F';
const FILL_BOTTOM = '#0A0503';

// The person icon sits centred above the count, the two together centred in the disc.
const ICON = { w: 16, h: 18, y: 6 };
const ICON_X = (DESIGN_WIDTH - ICON.w) / 2;

const COUNT_TOP = 25;
const COUNT_FONT = 10;

type Props = {
	label: string;
	width: number;
};

export const LobbyPlayersBadge = ({ label, width }: Props) => {
	const fillId = useSvgId('playersBadgeFill');

	if (width <= 0) return null;

	const scale = width / DESIGN_WIDTH;
	const height = width;
	const stroke = BORDER_WIDTH * scale;
	const radius = (width - stroke) / 2;

	return (
		<View style={[styles.root, { width, height, borderRadius: width / 2 }]} pointerEvents='none'>
			<Svg width={width} height={height} style={StyleSheet.absoluteFill}>
				<Defs>
					<LinearGradient id={fillId} x1='0' y1='0' x2='0' y2='1'>
						<Stop offset='0' stopColor={FILL_TOP} />
						<Stop offset='1' stopColor={FILL_BOTTOM} />
					</LinearGradient>
				</Defs>
				<Circle
					cx={width / 2}
					cy={height / 2}
					r={radius}
					fill={`url(#${fillId})`}
					stroke={BORDER_COLOR}
					strokeWidth={stroke}
				/>
			</Svg>

			<Image
				source={MainUserIcon}
				resizeMode='contain'
				style={{
					position: 'absolute',
					left: ICON_X * scale,
					top: ICON.y * scale,
					width: ICON.w * scale,
					height: ICON.h * scale,
				}}
			/>

			<Text
				numberOfLines={1}
				style={[
					styles.count,
					{ top: COUNT_TOP * scale, fontSize: COUNT_FONT * scale, lineHeight: 12 * scale },
				]}
			>
				{label}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		overflow: 'visible',
		shadowColor: '#000000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.6,
		shadowRadius: 3,
		elevation: 4,
	},
	count: {
		position: 'absolute',
		left: 0,
		right: 0,
		color: '#FFFFFF',
		fontFamily: 'Sofia Sans',
		fontWeight: '600',
		textAlign: 'center',
		includeFontPadding: false,
	},
});

export default LobbyPlayersBadge;
